/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：ダイアログジュール
 *
 * 作成者：2021/11/19 ノア）黄
 * 最終修正者：2021/11/19 ノア）黄
 *
 */
import { Module, VuexModule, getModule, Mutation } from 'vuex-module-decorators'

import store from '@/store'

/**
 * コモンモジュール
 *
 * @class
 */
@Module({
  dynamic: true,
  namespaced: true,
  name: 'dialog',
  store
})
class DialogModule extends VuexModule {
  /**
   * MFA認定スイッチ
   */
  isMFASwitchDialogShow = false

  /**
   * パスワード更新
   */
  isUpdatePsDialogShow = false

  /**
   * 機能一覧
   */
  isScreenDialogShow = false

  /**
   * CC(電話)
   */
  isPhoneCCDialogShow = false

  /**
   * 通知
   */
  isNotificationsDialogShow = false

  /**
   * メッセージ送信
   */
  isMessageSendDialogShow = false

  /**
   * 通知送信
   */
  isNotificationsSendDialogShow = false

  /**
   * サイドバー
   */
  silderBarIsShow = false

  /**
   * お気に入り
   */
  isShowFavoriteDialog = false

  /**
   * 位置情報
   */
  isLocationInfoShow = false

  /**
   * ユーザ追加と編集
   */
  isToolUserAddUpdateDialogShow = false

  /**
   * 初期化
   *
   * @returns {void}
   */
  @Mutation
  initStatus(): void {
    this.isMFASwitchDialogShow = false
    this.isUpdatePsDialogShow = false
    this.isScreenDialogShow = false
    this.isPhoneCCDialogShow = false
    this.isNotificationsDialogShow = false
    this.isMessageSendDialogShow = false
    this.isNotificationsSendDialogShow = false
    this.silderBarIsShow = false
    this.isShowFavoriteDialog = false
    this.isLocationInfoShow = false
    this.isToolUserAddUpdateDialogShow = false
  }

  /**
   * MFA認定スイッチポップアップ表示フラグを設定する
   *
   * @returns {void}
   */
  @Mutation
  setMFASwitchIsShow(): void {
    this.isMFASwitchDialogShow = !this.isMFASwitchDialogShow
  }

  /**
   * パスワード更新ポップアップ表示フラグを設定する
   *
   * @returns {void}
   */
  @Mutation
  setUpdatePsIsShow(): void {
    this.isUpdatePsDialogShow = !this.isUpdatePsDialogShow
  }

  /**
   * 機能一覧表示フラグを設定する
   *
   * @param {boolean} value 表示フラグ
   * @returns {void}
   */
  @Mutation
  setScreenDialogShow(value: boolean): void {
    this.isScreenDialogShow = value
  }

  /**
   * CC(電話)表示フラグを設定する
   *
   * @param {boolean} value 表示フラグ
   * @returns {void}
   */
  @Mutation
  setPhoneCCDialogShow(value: boolean): void {
    this.isPhoneCCDialogShow = value
  }

  /**
   * 通知表示フラグを設定する
   *
   * @returns {void}
   */
  @Mutation
  setNotificationsDialogShow(): void {
    this.isNotificationsDialogShow = !this.isNotificationsDialogShow
  }

  /**
   * メッセージ送信表示フラグを設定する
   *
   * @param {boolean} value 表示フラグ
   * @returns {void}
   */
  @Mutation
  setMessageSendDialogShow(value: boolean): void {
    this.isMessageSendDialogShow = value
  }

  /**
   * 通知送信表示フラグを設定する
   *
   * @param {boolean} value 表示フラグ
   * @returns {void}
   */
  @Mutation
  setNotificationsSendDialogShow(value: boolean): void {
    this.isNotificationsSendDialogShow = value
  }

  /**
   * サイドバー表示フラグを設定する
   *
   * @returns {void}
   */
  @Mutation
  setSilderBarIsShow(): void {
    this.silderBarIsShow = !this.silderBarIsShow
  }

  /**
   * お気に入り表示フラグを設定する
   *
   * @param {boolean} value 表示フラグ
   * @returns {void}
   */
  @Mutation
  setFavoriteDialogShow(value: boolean): void {
    this.isShowFavoriteDialog = value
  }

  /**
   * 位置情報表示フラグを設定する
   *
   * @param {boolean} value 表示フラグ
   * @returns {void}
   */
  @Mutation
  setLocationInfoShow(value: boolean): void {
    this.isLocationInfoShow = value
  }

  /**
   *  ユーザ追加と編集表示フラグを設定する
   *
   * @param {boolean} value 表示フラグ
   * @returns {void}
   */
  @Mutation
  setToolUserAddUpdateShow(value: boolean): void {
    this.isToolUserAddUpdateDialogShow = value
  }
}

export default getModule(DialogModule)
